import React from 'react';
import { NavLink } from 'react-router-dom';

const navItems = [
  { label: 'Dashboard', path: '/dashboard' },
  { label: 'Users',     path: '/users'     },
  { label: 'Analytics', path: '/analytics' },
  { label: 'Reports',   path: '/reports'   },
  { label: 'Settings',  path: '/settings'  },
];

function Sidebar() {
  return (
    <div className="sidebar">
      <div className="sidebar-brand">
        <h4>Thomas React</h4>
        <p>Thomas PoC Dashboard</p>
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            <span className="nav-icon">▪</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-footer">
        <p>© 2026 Thomas React</p>
      </div>
    </div>
  );
}

export default Sidebar;
